import classNames from 'classnames';
import type React from 'react';

export type RulePreviewLayout = 'grid' | 'flex';

export interface LayoutProps {
  layout?: RulePreviewLayout;
  children: React.ReactNode;
}

export const Layout = ({ layout = 'flex', children }: LayoutProps) => (
  <div
    className={classNames(
      layout === 'grid' ? 'grid grid-cols-[1fr_auto_1fr]' : 'flex',
      'flex-1 gap-1.5 min-w-0'
    )}
  >
    {children}
  </div>
);
